import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { Jugador } from '@domain/jugador';
import { Equipo } from '@domain/equipo';
import { ASSETS } from '@env';
import { DashboardProvider } from '@providers/dashboard/dashboard'
import { LoadingProvider } from '@providers/loading/loading';

@IonicPage()
@Component({
  selector: 'page-vs',
  templateUrl: 'vs.html',
})
export class VsPage {

  jugador: Jugador;
  oponente: Jugador;
  equipo: Equipo;
  estadistica: any;
  AVATAR_PLAYER = ASSETS.AVATAR_PLAYER;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private dashboardProvider: DashboardProvider,
    private loadingProvider: LoadingProvider,
  ) {
    this.jugador = navParams.get('jugador');
    this.oponente = navParams.get('oponente');
    this.equipo = navParams.get('equipo');
  }

  ionViewDidLoad() {
    this.dashboardProvider.vs(this.equipo.area._id, this.jugador._id, this.oponente._id)
      .then( estadistica => {
        this.estadistica = estadistica;
      })
      .then( _ => this.loadingProvider.show(false) )
      .catch( e => this.loadingProvider.show(false) )
  }

  calculaAnchoInsignias(oponente = false) {
    let total = this.estadistica.oponente.insignias + this.estadistica.jugador.insignias;
    if(oponente) {
      return `${(this.estadistica.oponente.insignias * 100 ) / total}%`;
    } else {
      return `${(this.estadistica.jugador.insignias * 100 ) / total}%`;
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/vs/vs.ts